import React, { useRef, useEffect } from 'react'
import { uploadImage } from '@/api/bug'
import Quill from 'quill'
import ImageUploader from '@/lib/quill-image-uploader/quill.imageUploader'
import codeImg from '@/assets/code.png'
import picImg from '@/assets/img.png'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import './style.less'

Quill.register('modules/imageUploader', ImageUploader)

const icons = Quill.import('ui/icons')
icons.image = `<div class="quill-icon-container"><img src='${picImg}' class="quill-icon-misrc"></div>`
icons[
  'code-block'
] = `<div class="quill-icon-container"><img src='${codeImg}' class="quill-icon-misrc"/></div>`

const TextArea = ({ quillRef, placeholder = '' }) => {
  const textAreaRef = useRef(null)
  useEffect(() => {
    const editor = new Quill(textAreaRef.current, {
      modules: {
        toolbar: [['image', 'code-block']],
        imageUploader: {
          upload: (file) => {
            return new Promise((resolve, reject) => {
              const formData = new FormData()
              formData.append('image', file)
              uploadImage(formData)
                .then((res) => resolve(res.data))
                .catch((err) => {
                  reject(err)
                })
            })
          },
        },
      },
      placeholder: `漏洞详情\n${placeholder}`,
      theme: 'snow',
    })
    quillRef.current = editor
  }, [quillRef, placeholder])

  return <div ref={textAreaRef} style={{ height: '375px' }} />
}

export default TextArea
